// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"0a940610","829":"957165bd"}[chunkId] + ".chunk.js";
};